import { getMessage } from 'util/locale';

export const getZoneNumbersInRange = ({
  minZoneCount, 
  maxZoneCount, 
  isSingleZoneRecommendationEnabled
}) => {
  const zoneNumbers = [];
  if(isSingleZoneRecommendationEnabled) {
    zoneNumbers.push({ id: 1, value: getMessage('single-zone') });
  }
  for (let i = minZoneCount; i <= maxZoneCount; ++i) { 
    zoneNumbers.push({ id: i, value: `${i}` }) ; 
  }
  return zoneNumbers;
};